var _defs, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightThing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            path\n            {\n                fill: #263c53;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.24,81.22c-9.16-9.15-23-30.33-23-41.38V35.79a23,23,0,0,0-46.06-.6,78.88,78.88,0,0,0,3.56,34.54h16.18C139.5,54.05,142,37.19,142.07,37l.1-.6v-.62a8,8,0,0,1,16.07,0v4.05c0,17.38,17.84,42.44,27.39,52,9,9,22,29.17,22,40.39h15C222.64,113.81,204.51,89.49,196.24,81.22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3,173.76h.48l2.71,0-.13-15-2.71,0h-.36a42.54,42.54,0,0,1-29.9-12.39L49.78,157A57.64,57.64,0,0,0,90.3,173.76Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.29,143.35h.49l2.71,0-.13-15-2.71,0A42.51,42.51,0,0,1,60.39,116l-10.61,10.6A57.63,57.63,0,0,0,90.29,143.35Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3,204.16h.48l2.71,0-.13-15-2.71,0h-.36a42.54,42.54,0,0,1-29.9-12.38L49.78,187.39A57.67,57.67,0,0,0,90.3,204.16Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.27,234.57h.48l5.45,0H217.62v-15H96.17l-5.52,0h-.36a42.54,42.54,0,0,1-29.9-12.38l-10.61,10.6A57.62,57.62,0,0,0,90.27,234.57Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.35,96h.35L109,96H153.1V81H109L90.78,81a57.83,57.83,0,0,0-35,11.55,56.36,56.36,0,0,0-6,5.22l10.61,10.61A42.58,42.58,0,0,1,90.35,96Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightThing);
export default __webpack_public_path__ + "static/media/right-thing.57d44a0b8139a4bbc266cf54ceb8b5e1.svg";
export { ForwardRef as ReactComponent };